import { Box, Typography, Accordion, AccordionSummary, AccordionDetails, Card, Button, Stack } from "@mui/material";
import ExpandMore from "@mui/icons-material/ExpandMore";
import Telegram from "@mui/icons-material/Telegram";
import WhatsApp from "@mui/icons-material/WhatsApp";

const FAQS = [
  {
    q: "What is White Hat Bots?",
    a: "White Hat Bots is an algorithmic trading platform. You design or rent strategy templates, connect your broker, and our engine executes the strategy against your account."
  },
  {
    q: "Does it work with my broker?",
    a: "We currently support Alpaca (live + paper). Interactive Brokers and TD Ameritrade are next up. Connect via OAuth from the Broker Accounts page."
  },
  {
    q: "What's a paper account?",
    a: "A paper account uses real market data but simulated money. Perfect for testing a strategy before committing capital. Every Alpaca account can be toggled between paper and live."
  },
  {
    q: "How does testing work?",
    a: "Pick a bot template, choose a historical window and starting capital, and we run the strategy end-to-end. You get an equity curve, trade log, and risk stats."
  },
  {
    q: "What are rental fees?",
    a: "Marketplace templates are rented monthly. You can cancel any time. Your own custom bots are always free."
  }
];

export function HelpPage() {
  return (
    <Box sx={{ maxWidth: 720, mx: "auto" }}>
      <Typography variant="h2" sx={{ mb: 3 }}>Help & FAQ</Typography>

      <Stack spacing={1.5} sx={{ mb: 4 }}>
        {FAQS.map((f, i) => (
          <Accordion key={i} disableGutters square
            sx={{ bgcolor: "background.paper", borderRadius: 3, "&:before": { display: "none" } }}>
            <AccordionSummary expandIcon={<ExpandMore />} sx={{ px: 2.5 }}>
              <Typography fontWeight={600}>{f.q}</Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ px: 2.5, pt: 0 }}>
              <Typography variant="body2" color="text.secondary">{f.a}</Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </Stack>

      <Card sx={{ p: 3 }}>
        <Typography variant="h5" sx={{ mb: 2 }}>Still need help?</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Our support team is available on Telegram and WhatsApp.
        </Typography>
        <Stack direction="row" spacing={1.5}>
          <Button variant="outlined" startIcon={<Telegram />} href="https://t.me/WhiteHatSupportBot" target="_blank">
            Telegram
          </Button>
          <Button variant="outlined" startIcon={<WhatsApp />} href="https://wa.me/+17248352705" target="_blank">
            WhatsApp
          </Button>
        </Stack>
      </Card>
    </Box>
  );
}
